import { useState } from "react"

/**
 * Hook to manage all modal and dialog visibility states
 * Keeps modal logic centralized and easy to manage
 * @returns {Object} Modal states and setter functions
 */
export function useModalStates() {
  // Design Gallery Modal
  const [showDesignGallery, setShowDesignGallery] = useState(false)

  // Studio Manager Modal
  const [showStudioManager, setShowStudioManager] = useState(false)

  // Save Design Dialog
  const [showSaveDialog, setShowSaveDialog] = useState(false)
  const [saveDesignName, setSaveDesignName] = useState("")
  const [saveToStudio, setSaveToStudio] = useState(null)

  // Member View Modal
  const [showMemberView, setShowMemberView] = useState(false)

  // Design Preview Modal
  const [showDesignPreview, setShowDesignPreview] = useState(false)
  const [previewDesign, setPreviewDesign] = useState(null)

  // Export Modal
  const [showExportModal, setShowExportModal] = useState(false)

  // Confirmation Modal
  const [showConfirmation, setShowConfirmation] = useState(false)

  // Helper functions to open/close modals
  const openSaveDialog = (defaultName = "Untitled Design") => {
    setSaveDesignName(defaultName)
    setSaveToStudio(null)
    setShowSaveDialog(true)
  }

  const closeSaveDialog = () => {
    setShowSaveDialog(false)
    setSaveDesignName("")
    setSaveToStudio(null)
  }

  const openDesignPreview = design => {
    setPreviewDesign(design)
    setShowDesignPreview(true)
  }

  const closeDesignPreview = () => {
    setShowDesignPreview(false)
    setPreviewDesign(null)
  }

  return {
    // Design Gallery
    showDesignGallery,
    setShowDesignGallery,

    // Studio Manager
    showStudioManager,
    setShowStudioManager,

    // Save Dialog
    showSaveDialog,
    setShowSaveDialog,
    saveDesignName,
    setSaveDesignName,
    saveToStudio,
    setSaveToStudio,
    openSaveDialog,
    closeSaveDialog,

    // Member View
    showMemberView,
    setShowMemberView,

    // Design Preview
    showDesignPreview,
    setShowDesignPreview,
    previewDesign,
    setPreviewDesign,
    openDesignPreview,
    closeDesignPreview,

    // Export Modal
    showExportModal,
    setShowExportModal,

    // Confirmation Modal
    showConfirmation,
    setShowConfirmation,
  }
}
